import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  container: {
    display: 'grid',
    gridTemplateColumns: '335px 1fr',
    justifyContent: 'space-between',
    width: '100%',
    gap: 100,
    paddingLeft: 40,
    marginTop: 8,
    flex: 1,
    alignItems: 'flex-start',
    overflow: 'hidden',
    [theme.breakpoints.down(1320)]: {
      paddingLeft: 0,
      gap: 32,
    },
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr',
      gridTemplateRow: 'auto auto',
      gridTemplateAreas: `
      'upload'
      'required'
      `,
      background: 'white',
      gap: 16,
      paddingLeft: 16,
      paddingRight: 16,
      paddingTop: 16,
      paddingBottom: 16,
      marginTop: 0,
      borderRadius: '16px 16px 0px 0px',
      overflow: 'initial',
      flex: 'initial',
      position: 'relative',
      zIndex: 2,
    },
  },
}))

export default useStyles
